import { render, staticRenderFns } from "./ArtistsPage.vue?vue&type=template&id=bf0e22e0&scoped=true"
import script from "./ArtistsPage.vue?vue&type=script&lang=js"
export * from "./ArtistsPage.vue?vue&type=script&lang=js"
import style0 from "./ArtistsPage.vue?vue&type=style&index=0&id=bf0e22e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e22e0",
  null
  
)

export default component.exports